import BaseService from "./base.service";

class InvoiceService {
    getInvoices() {
        return BaseService.apiGetRequest('invoice', null, null, false);
    }

}
export default new InvoiceService();
